<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  /* font-family: Roboto; */
  font-family: monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #0b2244;
  height: 100%;
  width: 100%;
  position: absolute;
}

.cornerstone-canvas {
  width: 100% !important;
  border-radius: 8px;
}

body {
  background-color: var(--q-dark);
  overflow-y: overlay;
}

body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

body::-webkit-scrollbar {
  width: 12px;
  background-color: var(--q-secondary);
}

body::-webkit-scrollbar-thumb {
  background-color: var(--q-secondary);
  border: 1px solid #555555;
}
</style>
